import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import SignIn from './components/SignIn/SignIn';
import Login from './components/signin-new/page';
import PasswordScreen from './components/signin-new/password/page';
import WorkspaceSelectionPage from './components/workspace-selection/page';
import CorpSelectionPage from './components/corp-selection/page';
import LegalEntitySelectionPage from './components/legal-entity-selection/page';
import Dashboard from './components/Dashboard/Dashboard';
import ProtectedRoute from './components/ProtectedRoute';
import MobileAppBanner from './components/common/MobileAppBanner';
import loadEnvStyles from './styles/envStyleLoader';
import './App.css';
import './styles/antd-overrides.css';
import './styles/env-styles.css';

const App: React.FC = () => {
  // Load environment-specific styles
  useEffect(() => {
    loadEnvStyles();
  }, []);

  return (
    <Router>
      <MobileAppBanner />
      <Routes>
        <Route path="/signin" element={<Login/>} />
        <Route path="/signin-new" element={<Login/>} />
        <Route path="/signin-new/password" element={<PasswordScreen />} />
        <Route path="/workspace-selection" element={<WorkspaceSelectionPage />} />
        <Route path="/corp-selection" element={<CorpSelectionPage />} />
        <Route path="/legal-entity-selection" element={<LegalEntitySelectionPage />} />
        <Route 
          path="/dashboard" 
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } 
        />
        <Route path="/" element={<Navigate to="/signin-new" replace />} />
        <Route path="*" element={<Navigate to="/signin-new" replace />} />
      </Routes>
    </Router>
  );
};

export default App;
